/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { associateStationSvgFile } from '../fn/sites-synoptics/associate-station-svg-file';
import { AssociateStationSvgFile$Params } from '../fn/sites-synoptics/associate-station-svg-file';
import { createStationSvgMetadata } from '../fn/sites-synoptics/create-station-svg-metadata';
import { CreateStationSvgMetadata$Params } from '../fn/sites-synoptics/create-station-svg-metadata';
import { getStationSvgFile } from '../fn/sites-synoptics/get-station-svg-file';
import { GetStationSvgFile$Params } from '../fn/sites-synoptics/get-station-svg-file';
import { getStationSvgFilesMetadata } from '../fn/sites-synoptics/get-station-svg-files-metadata';
import { GetStationSvgFilesMetadata$Params } from '../fn/sites-synoptics/get-station-svg-files-metadata';
import { getSvgTags } from '../fn/sites-synoptics/get-svg-tags';
import { GetSvgTags$Params } from '../fn/sites-synoptics/get-svg-tags';
import { removeSvgAssociation } from '../fn/sites-synoptics/remove-svg-association';
import { RemoveSvgAssociation$Params } from '../fn/sites-synoptics/remove-svg-association';
import { SvgFileMetadataList } from '../models/svg-file-metadata-list';
import { SvgNodeList } from '../models/svg-node-list';
import { updateStationSvgMetadata } from '../fn/sites-synoptics/update-station-svg-metadata';
import { UpdateStationSvgMetadata$Params } from '../fn/sites-synoptics/update-station-svg-metadata';
import { updateSvgAssociation } from '../fn/sites-synoptics/update-svg-association';
import { UpdateSvgAssociation$Params } from '../fn/sites-synoptics/update-svg-association';

@Injectable({ providedIn: 'root' })
export class SitesSynopticsService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStationSvgFilesMetadata()` */
  static readonly GetStationSvgFilesMetadataPath = '/stations/{uid}/svg';

  /**
   * Get a station SVG files metadata.
   *
   * Get a station SVG files metadata
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationSvgFilesMetadata()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationSvgFilesMetadata$Response(params: GetStationSvgFilesMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgFileMetadataList>> {
    return getStationSvgFilesMetadata(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station SVG files metadata.
   *
   * Get a station SVG files metadata
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationSvgFilesMetadata$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationSvgFilesMetadata(params: GetStationSvgFilesMetadata$Params, context?: HttpContext): Observable<SvgFileMetadataList> {
    return this.getStationSvgFilesMetadata$Response(params, context).pipe(
      map((r: StrictHttpResponse<SvgFileMetadataList>): SvgFileMetadataList => r.body)
    );
  }

  /** Path part for operation `updateStationSvgMetadata()` */
  static readonly UpdateStationSvgMetadataPath = '/stations/{uid}/svg';

  /**
   * update a list of SVG metadata for a station (allows to update the order).
   *
   * Allows to update a list of SVG metadata for a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStationSvgMetadata()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStationSvgMetadata$Response(params: UpdateStationSvgMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateStationSvgMetadata(this.http, this.rootUrl, params, context);
  }

  /**
   * update a list of SVG metadata for a station (allows to update the order).
   *
   * Allows to update a list of SVG metadata for a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStationSvgMetadata$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStationSvgMetadata(params: UpdateStationSvgMetadata$Params, context?: HttpContext): Observable<void> {
    return this.updateStationSvgMetadata$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createStationSvgMetadata()` */
  static readonly CreateStationSvgMetadataPath = '/stations/{uid}/svg';

  /**
   * Create an SVG metadata with a station.
   *
   * Allows to associate an SVG metadata to a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStationSvgMetadata()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStationSvgMetadata$Response(params: CreateStationSvgMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createStationSvgMetadata(this.http, this.rootUrl, params, context);
  }

  /**
   * Create an SVG metadata with a station.
   *
   * Allows to associate an SVG metadata to a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStationSvgMetadata$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStationSvgMetadata(params: CreateStationSvgMetadata$Params, context?: HttpContext): Observable<void> {
    return this.createStationSvgMetadata$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSvgAssociation()` */
  static readonly UpdateSvgAssociationPath = '/stations/{uid}/svg/{svgUid}';

  /**
   * Update the SVG file metadata associated with station.
   *
   * Update SVG file metadata associated to station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSvgAssociation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSvgAssociation$Response(params: UpdateSvgAssociation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSvgAssociation(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the SVG file metadata associated with station.
   *
   * Update SVG file metadata associated to station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSvgAssociation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSvgAssociation(params: UpdateSvgAssociation$Params, context?: HttpContext): Observable<void> {
    return this.updateSvgAssociation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeSvgAssociation()` */
  static readonly RemoveSvgAssociationPath = '/stations/{uid}/svg/{svgUid}';

  /**
   * Remove the SVG file association to station.
   *
   * Remove SVG file association to station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSvgAssociation()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSvgAssociation$Response(params: RemoveSvgAssociation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeSvgAssociation(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the SVG file association to station.
   *
   * Remove SVG file association to station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeSvgAssociation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSvgAssociation(params: RemoveSvgAssociation$Params, context?: HttpContext): Observable<void> {
    return this.removeSvgAssociation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStationSvgFile()` */
  static readonly GetStationSvgFilePath = '/stations/{uid}/svg/{svgUid}/file';

  /**
   * Retrieve an SVG file associated with a station.
   *
   * Allows to retrieve an SVG file associated to a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationSvgFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationSvgFile$Response(params: GetStationSvgFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getStationSvgFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve an SVG file associated with a station.
   *
   * Allows to retrieve an SVG file associated to a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationSvgFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationSvgFile(params: GetStationSvgFile$Params, context?: HttpContext): Observable<Blob> {
    return this.getStationSvgFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `associateStationSvgFile()` */
  static readonly AssociateStationSvgFilePath = '/stations/{uid}/svg/{svgUid}/file';

  /**
   * Associate an SVG file with a station.
   *
   * Allows to associate an SVG file to a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `associateStationSvgFile()` instead.
   *
   * This method sends `image/svg+xml` and handles request body of type `image/svg+xml`.
   */
  associateStationSvgFile$Response(params: AssociateStationSvgFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return associateStationSvgFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Associate an SVG file with a station.
   *
   * Allows to associate an SVG file to a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `associateStationSvgFile$Response()` instead.
   *
   * This method sends `image/svg+xml` and handles request body of type `image/svg+xml`.
   */
  associateStationSvgFile(params: AssociateStationSvgFile$Params, context?: HttpContext): Observable<void> {
    return this.associateStationSvgFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSvgTags()` */
  static readonly GetSvgTagsPath = '/stations/{uid}/svg/{svgUid}/tags';

  /**
   * Get the tags needed to fill out the data in the SVG file.
   *
   * Get the tags needed to fill out the data in the SVG file
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSvgTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgTags$Response(params: GetSvgTags$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgNodeList>> {
    return getSvgTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags needed to fill out the data in the SVG file.
   *
   * Get the tags needed to fill out the data in the SVG file
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSvgTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgTags(params: GetSvgTags$Params, context?: HttpContext): Observable<SvgNodeList> {
    return this.getSvgTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<SvgNodeList>): SvgNodeList => r.body)
    );
  }

}
